import ContactForm from "../common/ContactForm";

function OrangeContactForm() {
    return (
        <ContactForm
            endpoint="/api/v1/orangeContact"
            title="Jestem zainteresowany ofertą"
            lead="Zostaw numer telefonu i krótką wiadomość — dedykowany opiekun Orange skontaktuje się z parafią."
            messagePlaceholder="Np. liczba numerów, którymi parafia jest zainteresowana, preferowane godziny kontaktu"
            successMessage="Wiadomość została wysłana. Opiekun Orange wkrótce się z Tobą skontaktuje."
        />
    )
}

export default OrangeContactForm;
